import { ref, onMounted, onUnmounted } from "vue"

function calculateRemaining(state) {
    const expiry = localStorage.getItem(state.key)

    if (!expiry) {
        state.remaining.value = 0
        return
    }

    const diff = Math.floor((Number(expiry) - Date.now()) / 1000)
    state.remaining.value = diff > 0 ? diff : 0
}

function start(state) {
    const expiry = Date.now() + state.duration * 1000
    localStorage.setItem(state.key, expiry.toString())
    calculateRemaining(state)
}

function tick(state) {
    calculateRemaining(state)

    if (state.remaining.value === 0 && state.timer.value) {
        clearInterval(state.timer.value)
        state.timer.value = null
    }
}

function startCooldown(state) {
    start(state)

    if (state.timer.value) {
        clearInterval(state.timer.value)
    }

    state.timer.value = window.setInterval(() => tick(state), 1000)
}

export function useCooldown(key, duration = 60) {
    const state = {
        key,
        duration,
        remaining: ref(0),
        timer: ref(null)
    }

    onMounted(() => {
        calculateRemaining(state)

        if (state.remaining.value > 0) {
            state.timer.value = window.setInterval(() => tick(state), 1000)
        }
    })

    onUnmounted(() => {
        if (state.timer.value) {
            clearInterval(state.timer.value)
        }
    })

    return {
        remaining: state.remaining,
        startCooldown: () => startCooldown(state)
    }
}